// extracted by mini-css-extract-plugin
export default {"basketButton":"Settings_basketButton__xHZu7"};